export default __webpack_public_path__ + "assets/images/fded5821a87a82530595d603482d3a4a.svg";